export const USUARIOS_LIST = "USUARIOS_LIST";
export const USUARIOS_LOADING = "USUARIOS_LOADING";
export const USUARIOS_CREATE = "USUARIOS_CREATE";
export const USUARIOS_UPDATE = "USUARIOS_UPDATE";
export const USUARIOS_DESTROY = "USUARIOS_DESTROY";

export const PERMISOS_LIST = "PERMISOS_LIST"

export const DOCTORES_LIST = "DOCTORES_LIST";